var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-operate"},[_c('div',{staticClass:"operate",on:{"click":function($event){return _vm.operateFn(3)}}},[_c('OssImg',{on:{"getImages":_vm.getImages}}),_c('span',{staticClass:"text-font"},[_vm._v("相册")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }